export function OutlineGestionIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 15.0479C13.8177 15.0479 15.2914 13.52 15.2914 11.6353C15.2914 9.75054 13.8177 8.22266 11.9999 8.22266C10.1821 8.22266 8.7085 9.75054 8.7085 11.6353C8.7085 13.52 10.1821 15.0479 11.9999 15.0479Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4829 6.90872C18.48 4.85581 18.84 2.92288 18.9621 2.38299L16.4293 0.856644C16.0821 1.18324 14.5007 2.58962 12.09 2.56962C9.64714 2.54962 8.07857 1.08326 7.74429 0.75L5.18571 2.28968C5.295 2.80957 5.655 4.76916 4.58786 6.82207C3.36643 9.18157 1.18071 9.88809 0.762857 10.0081L0.75 13.1074C1.17429 13.2474 3.24429 13.9739 4.42714 16.2468C5.53286 18.373 5.12143 20.4126 5.00571 20.8991L7.57071 22.4855C7.91143 22.1655 9.57643 20.6792 12.0836 20.7658C14.3721 20.8391 15.8571 22.1722 16.23 22.5321L18.8207 21.0524C18.7243 20.5725 18.3321 18.3597 19.6436 16.1535C20.8521 14.1139 22.7164 13.434 23.2114 13.2674L23.25 10.2347C22.8193 10.0881 20.6529 9.30155 19.4829 6.90205V6.90872Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
